import { AboutSectionProps } from "@/src/sections/about/v1";
import { FaAppStore, FaGooglePlay } from "react-icons/fa6";

export const aboutSectionData_en: AboutSectionProps = {
  images: {
    image1: {
      src: "/assets/images/about/AboutUs196_133.webp",
      alt: "about one",
      width: 195,
      height: 132,
    },
    image2: {
      src: "/assets/images/about/AboutUs313_305.webp",
      alt: "about two",
      width: 312,
      height: 304,
    },
    image3: {
      src: "/assets/images/about/AboutUs250_265.webp",
      alt: "about three",
      width: 250,
      height: 265,
    },
    image4: {
      src: "/assets/images/about/AboutUs251_266.webp",
      alt: "about four",
      width: 250,
      height: 265,
    },
  },
  sectionHeading: {
    subtitle: "About us",
    title: "SELECTING THE FINEST IT SERVICE PROVIDER",
    description:
      "Our company Smart Oasis is a pioneering leader in Iraq telecom and IT sectors, dedicated to innovation and cybersecurity.Driven with ambition, we harness global expertise and partnerships to shape a secure technological future.",
  },
  keyPoints: [
    {
      icon: <FaAppStore size={40} style={{ height: "66px" }} />,
      title: "SOC Ios app",
      img: "/assets/images/about/appstore.webp",
    },
    {
      icon: <FaGooglePlay size={40} style={{ height: "66px" }} />,
      title: "SOC Android app",
      img: "/assets/images/about/googleplay.webp",
    },
  ],
  description:
    "Committed to excellence, we deliver customized solutions for a sustainable digital environment, reinforcing our essential role in Iraq economy and society.",
};
